import { useGLTF } from '@react-three/drei';

function Kamino() {
  const { nodes, materials } = useGLTF('/models/CaminoFinal.gltf');
  return (
    <group dispose={null}>
      <group position={[-32.88, 29.33, 7.93]} scale={[1, 1.5, 1]}>
        <mesh geometry={nodes.Cubo115.geometry} material={materials['brown.022']} />
        <mesh geometry={nodes.Cubo115_1.geometry} material={materials['green claro.016']} />
        <mesh geometry={nodes.Cubo115_2.geometry} material={materials.brown} />
        <mesh geometry={nodes.Cubo115_3.geometry} material={materials.purple} />
        <mesh geometry={nodes.Cubo115_4.geometry} material={materials['grey.028']} />
        <mesh geometry={nodes.Cubo115_5.geometry} material={materials['brown.002']} />
        <mesh geometry={nodes.Cubo115_6.geometry} material={materials['green claro.002']} />
        <mesh geometry={nodes.Cubo115_7.geometry} material={materials['brown.003']} />
        <mesh geometry={nodes.Cubo115_8.geometry} material={materials['green claro.003']} />
        <mesh geometry={nodes.Cubo115_9.geometry} material={materials['brown.004']} />
        <mesh geometry={nodes.Cubo115_10.geometry} material={materials['green claro.004']} />
        <mesh geometry={nodes.Cubo115_11.geometry} material={materials['brown.005']} />
        <mesh geometry={nodes.Cubo115_12.geometry} material={materials['purple superlight']} />
        <mesh geometry={nodes.Cubo115_13.geometry} material={materials['brown.006']} />
        <mesh geometry={nodes.Cubo115_14.geometry} material={materials['green claro.006']} />
        <mesh geometry={nodes.Cubo115_15.geometry} material={materials['brown.007']} />
        <mesh geometry={nodes.Cubo115_16.geometry} material={materials['green claro.007']} />
        <mesh geometry={nodes.Cubo115_17.geometry} material={materials.orange} />
        <mesh geometry={nodes.Cubo115_18.geometry} material={materials.white} />
        <mesh geometry={nodes.Cubo115_19.geometry} material={materials['black ']} />
        <mesh geometry={nodes.Cubo115_20.geometry} material={materials['black .001']} />
        <mesh geometry={nodes.Cubo115_21.geometry} material={materials['black .002']} />
        <mesh geometry={nodes.Cubo115_22.geometry} material={materials['yellow light.003']} />
        <mesh geometry={nodes.Cubo115_23.geometry} material={materials['white.001']} />
        <mesh geometry={nodes.Cubo115_24.geometry} material={materials['black .003']} />
        <mesh geometry={nodes.Cubo115_25.geometry} material={materials['black .004']} />
        <mesh geometry={nodes.Cubo115_26.geometry} material={materials['black .005']} />
        <mesh geometry={nodes.Cubo115_27.geometry} material={materials['grey.004']} />
        <mesh geometry={nodes.Cubo115_28.geometry} material={materials['brown.008']} />
        <mesh geometry={nodes.Cubo115_29.geometry} material={materials['green claro.008']} />
        <mesh geometry={nodes.Cubo115_30.geometry} material={materials['brown.009']} />
        <mesh geometry={nodes.Cubo115_31.geometry} material={materials['green claro.009']} />
        <mesh geometry={nodes.Cubo115_32.geometry} material={materials['brown.010']} />
        <mesh geometry={nodes.Cubo115_33.geometry} material={materials['green claro.010']} />
        <mesh geometry={nodes.Cubo115_34.geometry} material={materials['brown.011']} />
        <mesh geometry={nodes.Cubo115_35.geometry} material={materials['green claro.011']} />
        <mesh geometry={nodes.Cubo115_36.geometry} material={materials.celeste} />
        <mesh geometry={nodes.Cubo115_37.geometry} material={materials['grey.007']} />
        <mesh geometry={nodes.Cubo115_38.geometry} material={materials['grey.005']} />
        <mesh geometry={nodes.Cubo115_39.geometry} material={materials['grey.006']} />
        <mesh geometry={nodes.Cubo115_40.geometry} material={materials['grey.008']} />
        <mesh geometry={nodes.Cubo115_41.geometry} material={materials['grey.009']} />
        <mesh geometry={nodes.Cubo115_42.geometry} material={materials['grey.010']} />
        <mesh geometry={nodes.Cubo115_43.geometry} material={materials['grey.011']} />
        <mesh geometry={nodes.Cubo115_44.geometry} material={materials['grey.012']} />
        <mesh geometry={nodes.Cubo115_45.geometry} material={materials['grey.013']} />
        <mesh geometry={nodes.Cubo115_46.geometry} material={materials['grey.014']} />
        <mesh geometry={nodes.Cubo115_47.geometry} material={materials['grey.015']} />
        <mesh geometry={nodes.Cubo115_48.geometry} material={materials['grey.016']} />
        <mesh geometry={nodes.Cubo115_49.geometry} material={materials['grey.017']} />
        <mesh geometry={nodes.Cubo115_50.geometry} material={materials['grey.018']} />
        <mesh geometry={nodes.Cubo115_51.geometry} material={materials['grey.019']} />
        <mesh geometry={nodes.Cubo115_52.geometry} material={materials['grey.020']} />
        <mesh geometry={nodes.Cubo115_53.geometry} material={materials['grey.021']} />
        <mesh geometry={nodes.Cubo115_54.geometry} material={materials['brown.012']} />
        <mesh geometry={nodes.Cubo115_55.geometry} material={materials['purple light']} />
        <mesh geometry={nodes.Cubo115_56.geometry} material={materials['brown.013']} />
        <mesh geometry={nodes.Cubo115_57.geometry} material={materials['green claro.012']} />
        <mesh geometry={nodes.Cubo115_58.geometry} material={materials['blue light']} />
        <mesh geometry={nodes.Cubo115_59.geometry} material={materials.bluesky} />
        <mesh geometry={nodes.Cubo115_60.geometry} material={materials['brown.014']} />
        <mesh geometry={nodes.Cubo115_61.geometry} material={materials['green claro.005']} />
        <mesh geometry={nodes.Cubo115_62.geometry} material={materials['brown.015']} />
        <mesh geometry={nodes.Cubo115_63.geometry} material={materials['purple superlight.001']} />
        <mesh geometry={nodes.Cubo115_64.geometry} material={materials['brown.016']} />
        <mesh geometry={nodes.Cubo115_65.geometry} material={materials['purple light.001']} />
        <mesh geometry={nodes.Cubo115_66.geometry} material={materials['brown.017']} />
        <mesh geometry={nodes.Cubo115_67.geometry} material={materials['green claro.013']} />
        <mesh geometry={nodes.Cubo115_68.geometry} material={materials['grey.022']} />
        <mesh geometry={nodes.Cubo115_69.geometry} material={materials['celeste super claro']} />
        <mesh geometry={nodes.Cubo115_70.geometry} material={materials['green super claro']} />
        <mesh geometry={nodes.Cubo115_71.geometry} material={materials['brown.018']} />
        <mesh geometry={nodes.Cubo115_72.geometry} material={materials['green claro.014']} />
        <mesh geometry={nodes.Cubo115_73.geometry} material={materials['brown.019']} />
        <mesh geometry={nodes.Cubo115_74.geometry} material={materials['purple superlight.002']} />
        <mesh geometry={nodes.Cubo115_75.geometry} material={materials['grey.023']} />
        <mesh geometry={nodes.Cubo115_76.geometry} material={materials['brown.020']} />
        <mesh geometry={nodes.Cubo115_77.geometry} material={materials['green claro.015']} />
        <mesh geometry={nodes.Cubo115_78.geometry} material={materials['brown.021']} />
        <mesh geometry={nodes.Cubo115_79.geometry} material={materials['purple light.002']} />
      </group>
      <group position={[-43.23, 30.54, 37.8]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
        <mesh geometry={nodes.Cubo071.geometry} material={materials['green claro.003']} />
        <mesh geometry={nodes.Cubo071_1.geometry} material={materials['blue light']} />
        <mesh geometry={nodes.Cubo071_2.geometry} material={materials.celeste} />
        <mesh geometry={nodes.Cubo071_3.geometry} material={materials.bluesky} />
      </group>
      <group position={[-50.45, 29.92, 36.76]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo090.geometry} material={materials['nude skin']} />
        <mesh geometry={nodes.Cubo090_1.geometry} material={materials['brown skin']} />
        <mesh geometry={nodes.Cubo090_2.geometry} material={materials['blue people']} />
      </group>
      <group position={[-51.2, 29.92, 37.07]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo093.geometry} material={materials['nude skin.001']} />
        <mesh geometry={nodes.Cubo093_1.geometry} material={materials['brown skin.001']} />
        <mesh geometry={nodes.Cubo093_2.geometry} material={materials['blue light']} />
      </group>
      <group position={[-67.41, 29.92, 36.76]} rotation={[0, 1.5, 0]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo094.geometry} material={materials['nude skin.002']} />
        <mesh geometry={nodes.Cubo094_1.geometry} material={materials['brown skin.002']} />
        <mesh geometry={nodes.Cubo094_2.geometry} material={materials['blue people.002']} />
      </group>
      <group
        position={[-71.16, 29.96, 40.49]}
        rotation={[-Math.PI, 0.21, -Math.PI]}
        scale={[1.48, 2.28, 2.12]}
      >
        <mesh geometry={nodes.Cubo095.geometry} material={materials['nude skin.003']} />
        <mesh geometry={nodes.Cubo095_1.geometry} material={materials['brown skin.003']} />
        <mesh geometry={nodes.Cubo095_2.geometry} material={materials['blue people.003']} />
      </group>
      <group position={[-81.63, 31.38, 36.45]} scale={[1, 1.24, 1]}>
        <mesh geometry={nodes.Cubo104.geometry} material={materials.yellow} />
        <mesh geometry={nodes.Cubo104_1.geometry} material={materials['green claroOne.010']} />
        <mesh geometry={nodes.Cubo104_2.geometry} material={materials.red} />
      </group>
      <group position={[-55.98, 29.92, 33.27]} rotation={[0, 1.5, 0]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo109.geometry} material={materials['nude skin.004']} />
        <mesh geometry={nodes.Cubo109_1.geometry} material={materials['brown skin.004']} />
        <mesh geometry={nodes.Cubo109_2.geometry} material={materials['blue people.004']} />
      </group>
      <group position={[-47.44, 29.55, 14.29]} rotation={[0, 1.18, 0]}>
        <mesh geometry={nodes.Cubo121.geometry} material={materials['grey.030']} />
        <mesh geometry={nodes.Cubo121_1.geometry} material={materials['brown.023']} />
        <mesh geometry={nodes.Cubo121_2.geometry} material={materials['black .007']} />
      </group>
      <group
        position={[-47.5, 30.01, 16.16]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[1.48, 2.28, 2.12]}
      >
        <mesh geometry={nodes.Cubo125.geometry} material={materials['nude skin.005']} />
        <mesh geometry={nodes.Cubo125_1.geometry} material={materials['brown skin.005']} />
        <mesh geometry={nodes.Cubo125_2.geometry} material={materials['blue light.001']} />
        <mesh geometry={nodes.Cubo125_3.geometry} material={materials['black .003']} />
        <mesh geometry={nodes.Cubo125_4.geometry} material={materials['grey.001']} />
        <mesh geometry={nodes.Cubo125_5.geometry} material={materials['blue people.002']} />
        <mesh geometry={nodes.Cubo125_6.geometry} material={materials['black ']} />
        <mesh geometry={nodes.Cubo125_7.geometry} material={materials['grey.029']} />
        <mesh geometry={nodes.Cubo125_8.geometry} material={materials.bluesky} />
        <mesh geometry={nodes.Cubo125_9.geometry} material={materials['black .006']} />
        <mesh geometry={nodes.Cubo125_10.geometry} material={materials['grey.031']} />
        <mesh geometry={nodes.Cubo125_11.geometry} material={materials['green claro.001']} />
        <mesh geometry={nodes.Cubo125_12.geometry} material={materials['black .008']} />
        <mesh geometry={nodes.Cubo125_13.geometry} material={materials.yellow} />
        <mesh geometry={nodes.Cubo125_14.geometry} material={materials['yellow.001']} />
        <mesh geometry={nodes.Cubo125_15.geometry} material={materials.glasses} />
        <mesh geometry={nodes.Cubo125_16.geometry} material={materials.pinky} />
        <mesh geometry={nodes.Cubo125_17.geometry} material={materials['grey.003']} />
        <mesh geometry={nodes.Cubo125_18.geometry} material={materials['grey.002']} />
      </group>
      <group
        position={[-42.81, 30.01, 16.16]}
        rotation={[Math.PI, -0.07, Math.PI]}
        scale={[1.48, 2.28, 2.12]}
      >
        <mesh geometry={nodes.Cubo126.geometry} material={materials['nude skin.006']} />
        <mesh geometry={nodes.Cubo126_1.geometry} material={materials['brown skin.006']} />
        <mesh geometry={nodes.Cubo126_2.geometry} material={materials['blue light.002']} />
      </group>
      <group position={[-68.67, 29.4, 12.14]} rotation={[0, -0.43, 0]}>
        <mesh geometry={nodes.Cubo145.geometry} material={materials['brown.031']} />
        <mesh geometry={nodes.Cubo145_1.geometry} material={materials['green claroOne']} />
        <mesh geometry={nodes.Cubo145_2.geometry} material={materials.brown} />
        <mesh geometry={nodes.Cubo145_3.geometry} material={materials['green claro']} />
        <mesh geometry={nodes.Cubo145_4.geometry} material={materials['brown.025']} />
        <mesh geometry={nodes.Cubo145_5.geometry} material={materials['blue light.003']} />
        <mesh geometry={nodes.Cubo145_6.geometry} material={materials['brown.026']} />
        <mesh geometry={nodes.Cubo145_7.geometry} material={materials['Material.016']} />
        <mesh geometry={nodes.Cubo145_8.geometry} material={materials['brown.027']} />
        <mesh geometry={nodes.Cubo145_9.geometry} material={materials['blue light.004']} />
        <mesh geometry={nodes.Cubo145_10.geometry} material={materials['brown.028']} />
        <mesh geometry={nodes.Cubo145_11.geometry} material={materials['green claro.018']} />
        <mesh geometry={nodes.Cubo145_12.geometry} material={materials['brown.029']} />
        <mesh geometry={nodes.Cubo145_13.geometry} material={materials['brown.030']} />
      </group>
      <group
        position={[-66.13, 30.09, 14.83]}
        rotation={[-Math.PI, 0.21, -Math.PI]}
        scale={[1.48, 2.28, 2.12]}
      >
        <mesh geometry={nodes.Cubo146.geometry} material={materials['nude skin.007']} />
        <mesh geometry={nodes.Cubo146_1.geometry} material={materials['brown skin.007']} />
        <mesh geometry={nodes.Cubo146_2.geometry} material={materials['blue people.006']} />
      </group>
      <group
        position={[-75.21, 30.09, 14.29]}
        rotation={[Math.PI, -0.96, Math.PI]}
        scale={[1.48, 2.28, 2.12]}
      >
        <mesh geometry={nodes.Cubo147.geometry} material={materials['nude skin.008']} />
        <mesh geometry={nodes.Cubo147_1.geometry} material={materials['brown skin.008']} />
        <mesh geometry={nodes.Cubo147_2.geometry} material={materials['blue people.007']} />
      </group>
      <group position={[-83.23, 29.92, 36.25]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo148.geometry} material={materials['nude skin.009']} />
        <mesh geometry={nodes.Cubo148_1.geometry} material={materials['brown skin.009']} />
        <mesh geometry={nodes.Cubo148_2.geometry} material={materials['blue people.008']} />
      </group>
      <group position={[-82.8, 29.92, 36.76]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo149.geometry} material={materials['nude skin.010']} />
        <mesh geometry={nodes.Cubo149_1.geometry} material={materials['brown skin.010']} />
        <mesh geometry={nodes.Cubo149_2.geometry} material={materials['blue people.009']} />
      </group>
      <mesh
        geometry={nodes.Cubo016.geometry}
        material={nodes.Cubo016.material}
        position={[-27.44, 17.2, 0]}
      />
      <group position={[-85.95, 29.98, 40.52]}>
        <mesh geometry={nodes.Cubo168.geometry} material={materials.yellow} />
        <mesh geometry={nodes.Cubo168_1.geometry} material={materials.red} />
        <mesh geometry={nodes.Cubo168_2.geometry} material={materials['grey.016']} />
      </group>
      <group position={[-86.45, 29.92, 40.84]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo171.geometry} material={materials['nude skin.011']} />
        <mesh geometry={nodes.Cubo171_1.geometry} material={materials['brown skin.011']} />
        <mesh geometry={nodes.Cubo171_2.geometry} material={materials['blue people.010']} />
      </group>
      <group position={[-63.06, 29.12, 40.41]}>
        <mesh geometry={nodes.Cubo174.geometry} material={materials['black ']} />
        <mesh geometry={nodes.Cubo174_1.geometry} material={materials['grey.001']} />
        <mesh geometry={nodes.Cubo174_2.geometry} material={materials['grey.016']} />
        <mesh geometry={nodes.Cubo174_3.geometry} material={materials.red} />
      </group>
      <mesh geometry={nodes.Cubo022.geometry} material={materials['blue light']} position={[-62.81, 30.8, 40.51]} rotation={[0, 0, Math.PI]} />
      <mesh geometry={nodes.Cubo019.geometry} material={materials['green claro']} position={[-42.17, 29.11, 35.31]} scale={[0.98, 1, 1]} />
      <group position={[-46.24, 29.32, 36.22]}>
        <mesh geometry={nodes.Cubo210.geometry} material={materials['grey.016']} />
        <mesh geometry={nodes.Cubo210_1.geometry} material={materials['grey.017']} />
        <mesh geometry={nodes.Cubo210_2.geometry} material={materials['grey.033']} />
        <mesh geometry={nodes.Cubo210_3.geometry} material={materials['grey.035']} />
        <mesh geometry={nodes.Cubo210_4.geometry} material={materials['grey.036']} />
      </group>
      <mesh geometry={nodes.Cubo027.geometry} material={materials['grey.018']} position={[-41.44, 29.37, 34.46]} rotation={[Math.PI / 2, Math.PI / 2, 0]} />
      <group position={[-76.94, 30.32, 10.95]} rotation={[Math.PI / 2, 0, -1.09]}>
        <mesh geometry={nodes.Cubo005_1.geometry} material={materials.bluesky} />
        <mesh geometry={nodes.Cubo005_2.geometry} material={materials['purple tambo']} />
        <mesh geometry={nodes.Cubo005_3.geometry} material={materials['yellow tambo']} />
        <mesh geometry={nodes.Cubo005_4.geometry} material={materials['purple oscuro']} />
        <mesh geometry={nodes.Cubo005_5.geometry} material={materials['brown skin.009']} />
      </group>
      <group
        position={[-74.11, 30.09, 14.29]}
        rotation={[Math.PI, -0.96, Math.PI]}
        scale={[1.48, 2.28, 2.12]}
      >
        <mesh geometry={nodes.Cubo001_1.geometry} material={materials['nude skin.012']} />
        <mesh geometry={nodes.Cubo001_2.geometry} material={materials['brown skin.012']} />
        <mesh geometry={nodes.Cubo001_3.geometry} material={materials['blue people.001']} />
      </group>
      <group position={[-86.88, 31.1, 43.46]}>
        <mesh geometry={nodes.Cubo_1.geometry} material={materials['brown skin']} />
        <mesh geometry={nodes.Cubo_2.geometry} material={materials.celeste} />
      </group>
      <group position={[-76.25, 29.92, 36.76]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo015_1.geometry} material={materials['nude skin.013']} />
        <mesh geometry={nodes.Cubo015_2.geometry} material={materials['brown skin.013']} />
        <mesh geometry={nodes.Cubo015_3.geometry} material={materials['blue people.005']} />
      </group>
      <group position={[-73.96, 29.92, 37.15]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo016_1.geometry} material={materials['nude skin.014']} />
        <mesh geometry={nodes.Cubo016_2.geometry} material={materials['brown skin.014']} />
        <mesh geometry={nodes.Cubo016_3.geometry} material={materials['blue people.011']} />
      </group>
      <group position={[-58.56, 29.92, 37.15]} scale={[1.48, 2.28, 2.12]}>
        <mesh geometry={nodes.Cubo017_1.geometry} material={materials['nude skin.015']} />
        <mesh geometry={nodes.Cubo017_2.geometry} material={materials['brown skin.015']} />
        <mesh geometry={nodes.Cubo017_3.geometry} material={materials['blue people.012']} />
      </group>
      <group position={[-26.7, 32.12, 5.06]} rotation={[-Math.PI, 1.04, -Math.PI]}>
        <mesh geometry={nodes.Cubo018_1.geometry} material={materials['pinky.002']} />
        <mesh geometry={nodes.Cubo018_2.geometry} material={materials['grey.034']} />
      </group>
      <group position={[-29.51, 32.12, 3.23]} rotation={[-Math.PI, 1.04, -Math.PI]}>
        <mesh geometry={nodes.Cubo019_1.geometry} material={materials['pinky.003']} />
        <mesh geometry={nodes.Cubo019_2.geometry} material={materials['grey.037']} />
      </group>
      <group position={[-82.99, 31.72, 12.51]} rotation={[Math.PI / 2, 0, -2.71]}>
        <mesh geometry={nodes.Cubo022_1.geometry} material={materials['grey.016']} />
        <mesh geometry={nodes.Cubo022_2.geometry} material={materials['yellow oxxo']} />
        <mesh geometry={nodes.Cubo022_3.geometry} material={materials['red oxxo']} />
        <mesh geometry={nodes.Cubo022_4.geometry} material={materials.celeste} />
        <mesh geometry={nodes.Cubo022_5.geometry} material={materials['grey.010']} />
        <mesh geometry={nodes.Cubo022_6.geometry} material={materials['Material.017']} />
        <mesh geometry={nodes.Cubo022_7.geometry} material={materials['celeste.001']} />
      </group>
      <mesh
        geometry={nodes.Cubo030.geometry}
        material={materials.brown}
        position={[-58.38, 29.37, 24.54]}
      />
      <mesh geometry={nodes.Cubo031.geometry} material={materials['green claro.001']} position={[-58.42, 30.21, 24.44]} />
      <mesh geometry={nodes.Cubo032.geometry} material={materials['green claro.017']} position={[-57.6, 30.21, 24.95]} />
      <mesh geometry={nodes.Cubo033.geometry} material={materials['brown.024']} position={[-57.55, 29.37, 25.05]} />
      <mesh geometry={nodes.Cubo034.geometry} material={materials['green claroOne']} position={[-58.42, 30.01, 25.67]} scale={[1, 0.64, 1]} />
      <mesh geometry={nodes.Cubo035.geometry} material={materials['brown.032']} position={[-58.38, 29.37, 25.77]} />
      <mesh
        geometry={nodes.Cubo036.geometry}
        material={materials.purple}
        position={[-59.08, 30.08, 24.43]}
        rotation={[0, -0.3, 0]}
        scale={[1, 0.82, 1]}
      />
      <mesh geometry={nodes.Cubo037.geometry} material={materials['brown.033']} position={[-59.06, 29.37, 24.54]} rotation={[0, -0.3, 0]} />
      <mesh geometry={nodes.Cubo038.geometry} material={materials['green claro.021']} position={[-54.51, 30.21, 24.23]} />
      <mesh geometry={nodes.Cubo039.geometry} material={materials['brown.034']} position={[-54.46, 29.37, 24.33]} />
      <mesh geometry={nodes.Cubo040.geometry} material={materials['brown.035']} position={[-53.51, 29.37, 23.92]} rotation={[0, 0.52, 0]} />
      <mesh geometry={nodes.Cubo041.geometry} material={materials['green claro.022']} position={[-53.6, 30.21, 23.86]} rotation={[0, 0.52, 0]} />
    </group>
  );
}

useGLTF.preload('/models/CaminoFinal.gltf');

export default Kamino;
